import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {ModalController} from "@ionic/angular";
import {ApiService} from "../../services/api.service";
import {Product, ProductStatus} from "../../models/ent-product.model";
import {CatalogProportion} from "../../models/catalog-propoptions.model";
import {NgxFileDropEntry} from "ngx-file-drop";
import {environment} from "../../../environments/environment";
import {ProductService} from "../../services/product.service";
import {CatalogCategories, PropertyType} from "../../models/catalog.model";

@Component({
  selector: 'app-form-new-product',
  templateUrl: './form-new-product.component.html',
  styleUrls: ['./form-new-product.component.scss'],
})
export class FormNewProductComponent implements OnInit {
  public readonly propertyType = PropertyType;
  @Input() product: any;
  form: FormGroup | undefined;
  formProperty: FormGroup | undefined;
  isSend = false;
  resp: any;
  proportions: CatalogProportion[] = [];
  files: NgxFileDropEntry[] = [];
  categories: CatalogCategories[] = [];
  propertyList: any[] = [];

  slideOpts = {
    slidesPerView: 2.3,
    spaceBetween: 16,
    speed: 400,
    pagination: false
  };
  FIELDS: any = [
    { title: null, name: 'Категория', alias: 'category', type: this.propertyType.Select, validators: [Validators.required] },
    { title: null, name: 'Подкатегория', alias: 'categoryId', type: this.propertyType.Select, validators: [Validators.required] },
    { title: null, name: 'Название', alias: 'name', type: this.propertyType.Text, validators: [Validators.required] },
    { title: null, name: 'Цена', alias: 'lease', type: this.propertyType.Number, validators: [Validators.required] },
    { title: null, name: 'Залог', subtitle: 'Берется перед арендой и возвращается, когда аренда закрывается. <b>0 - без залога</b>.', alias: 'deposit', type: this.propertyType.Number, validators: [Validators.required] },
    { title: null, name: 'Адрес', subtitle: 'Укажите место получения товара', alias: 'address', type: this.propertyType.Text, validators: [Validators.required] },
    { title: null, name: 'Ближайшее метро или другой ориентир', alias: 'refPoint', type: this.propertyType.Text, validators: [] },
    { title: null, name: 'Комментарий от владельца', alias: 'description', type: this.propertyType.Textarea, validators: [] }
  ];
  FIELDS_PROPERTY: any = [];

  constructor(
    private modalCtrl: ModalController,
    private productService: ProductService,
    private api: ApiService
  ) { }

  async ngOnInit() {
    this.proportions = await this.api.catalog.proportions().then();
    this.categories = await this.api.catalog.catalogCategories().then();
    this.form = new FormGroup({});
    for (const FIELD of this.FIELDS) {
      switch (FIELD.alias) {
        case 'category':
          // @ts-ignore
          this.form.addControl(FIELD.alias, new FormControl(this.categories.find(x => x.id === this.product?.categoryId)?.parentId, FIELD.validators));
          break;
        default:
          // @ts-ignore
          this.form.addControl(FIELD.alias, new FormControl(this.product[FIELD.alias], FIELD.validators));
          break;
      }
    }
    await this.initFormProperty();
  }

  private async initFormProperty(isLoading: boolean = false) {
    this.propertyList = await this.api.entProduct.propertyList(this.form?.value.categoryId, isLoading);
    this.FIELDS_PROPERTY = [];
    if (this.propertyList.length > 0) {
      for (let i = 0; i < this.propertyList.length; i++) {
        if (this.propertyList[i]?.propNames.length == 0) {
          this.FIELDS_PROPERTY.push({ fromList: this.propertyList[i].fromList, title: i == 0 ? 'Характеристики' : null, name: this.propertyList[i].text, alias: this.propertyList[i].alias, type: this.propertyList[i].fromList ? this.propertyType.Select : this.propertyList[i].propertyType, validators: [] });
        } else {
          if (this.propertyList[i].propertyType == this.propertyType.Range) {
            let _i = 0;
            const _propNames = this.propertyList[i]?.propNames;
            for (const _alias of _propNames) {
              this.FIELDS_PROPERTY.push({
                fromList: this.propertyList[i].fromList,
                title: _i == 0 ? this.propertyList[i].text : null,
                name: _i == 0 ? 'От' : 'До',
                alias: _alias,
                type: this.propertyList[i].propertyType,
                validators: []
              });
              _i++;
            }
          } else {
            this.FIELDS_PROPERTY.push({ fromList: this.propertyList[i].fromList, title: i == 0 ? 'Характеристики' : null, name: this.propertyList[i].text, alias: this.propertyList[i]?.alias, type: this.propertyList[i].fromList ? this.propertyType.Select : this.propertyList[i].propertyType, validators: [] });
          }
        }
      }
    }
    this.formProperty = new FormGroup({});
    for (const FIELD of this.FIELDS_PROPERTY) {
      switch (FIELD.alias) {
        case 'category':
          // @ts-ignore
          this.formProperty.addControl(FIELD.alias, new FormControl(this.categories.find(x => x.id === this.product?.categoryId)?.parentId, FIELD.validators));
          break;
        default:
          let value = this.product[FIELD.alias];
          let isFree = false;
          if (value != null && this.getProportions(FIELD.alias).length > 0 && !this.getProportions(FIELD.alias).find(x => x.value == value)) {
            value = ''; isFree = true;
          }
          // @ts-ignore
          this.formProperty.addControl(FIELD.alias, new FormControl(value ?? null, FIELD.validators));
          if (this.getProportions(FIELD.alias, true).length > 0 && this.getProportions(FIELD.alias, true)[0].isFree) {
            this.formProperty.addControl(`${FIELD.alias}_free`, new FormControl(this.product[FIELD.alias], []));
          }
          break;
      }
    }
  }

  async send(isPublished: boolean = false) {
    this.isSend = true;
    if (isPublished) {
      this.form?.markAllAsTouched();
      this.formProperty?.markAllAsTouched();
      if (this.form?.invalid || this.formProperty?.invalid) {
        this.isSend = false;
        return;
      }
    }
    if (this.product) {
      await this.mappingProduct(isPublished);
      this.product = await this.api.entProduct.save(this.product).then();
      this.productService.isProductUpdate$.next(true);
      this.isSend = false;
      this.modalCtrl.dismiss(this.product, 'confirm').then();
    }
  }

  async saveField(alias: string) {
    if (!alias) { return; }
    const control = this.form?.get(alias);
    if (control) {
      if (alias === 'category') {
        this.form?.get('categoryId')?.reset();
      }
      control.markAllAsTouched();
      if (control.valid && this.product) {
        await this.mappingProduct();
        this.product = await this.api.entProduct.save(this.product).then();
        if (alias == 'categoryId') {
          await this.initFormProperty(true);
        }
      }
    } else {
      const propCtrl = this.formProperty?.get(alias);
      const prop = this.getProportions(alias).find(x => x.value === propCtrl?.value);
      if (prop && prop.isFree && this.formProperty) {
        this.formProperty.addControl(`${alias}_free`, new FormControl('', []));
      } else {
        if (this.formProperty?.contains(`${alias}_free`)) {this.formProperty?.removeControl(`${alias}_free`);}
      }
      if (propCtrl) {
        propCtrl?.markAllAsTouched();
        if (propCtrl.valid && this.product) {
          await this.mappingProduct();
          this.product = await this.api.entProduct.save(this.product).then();
        }
      }
    }
  }

  private async mappingProduct(isPublished: boolean = false) {
    if (this.product) {
      if (this.form) {
        isPublished ? this.product.status = ProductStatus.Available : this.product.status = ProductStatus.Draft;
        for (const _ctrl in this.form?.controls) {
          const ctrl = this.form?.get(_ctrl);
          if (ctrl?.valid)
          { // @ts-ignore
            this.product[_ctrl] = ctrl?.value
          }
        }
      }
      if (this.formProperty) {
        isPublished ? this.product.status = ProductStatus.Available : this.product.status = ProductStatus.Draft;
        for (const _ctrl in this.formProperty?.controls) {
          let aliasCtrl = _ctrl;
          if (_ctrl.indexOf('_free') != -1) {
            aliasCtrl = _ctrl.replace('_free', '');
          }
          const ctrl = this.formProperty?.get(_ctrl);
          if (ctrl?.valid)
          {
            let value = ctrl?.value;
            if (value == 'null') { value = null; }
            this.product[aliasCtrl] = value ? `${value}` : null
          }
        }
      }
    }
  }

  getProportions(alias: string, isFree: boolean = false) {
    switch (alias) {
      case 'category':
        const _proportionsCat: CatalogProportion[] = [];
          for (const cat of this.categories.filter(x => !x.parentId)) {
            _proportionsCat.push({ property: 'category', text: cat.name, value: cat.id, isFree: false })
          }
        return _proportionsCat;
      case 'categoryId':
        const _proportionsSubCat: CatalogProportion[] = [];
        for (const cat of this.categories.filter(x => x.parentId && x.parentId === this.form?.get('category')?.value)) {
          _proportionsSubCat.push({ property: 'subCategory', text: cat.name, value: cat.id, isFree: false })
        }
        return _proportionsSubCat;
      default:
        let resp = this.proportions.filter(x => x.property.toLowerCase() === alias.toLowerCase());
        if (resp.length == 0)
        {
          const _alias = this.propertyList.find(x => x.propNames.includes(alias))?.alias;
          resp = this.proportions.filter(x => x.property.toLowerCase() === _alias.toLowerCase());
        }
        return isFree ? resp.filter(x => x.isFree) : resp;
    }
  }

  async dropped(files: NgxFileDropEntry[]): Promise<any> {
    this.files = [];
    const formData = new FormData();
    // @ts-ignore
    formData.append('entityId', this.product?.id);
    formData.delete('files');
    for (let _f of files) {
      if (this.isFileAllowed(_f.fileEntry.name)) {
        this.files.push(_f);
        let i = 0;
        for (const droppedFile of this.files) {
          if (droppedFile.fileEntry.isFile) {
            const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
            fileEntry.file((file: File) => {
              let flag = true;
              for (let data of formData.getAll('files')) {
                // @ts-ignore
                if (data.name === file.name) {
                  flag = false;
                }
              }
              if (flag) { formData.append('files', file); }
            });
          }
        }
      }
    }
    this.api.media.upload(formData).then(async resp => {
      for (let f of resp) {
        // @ts-ignore
        this.product?.photosIds.push(f?.id);
      }
    });
  }

  async mediaRemove(mediaId: string) {
    if (this.product && this.product.id) {
      const removed = await this.api.entProduct.mediaRemove(this.product.id, mediaId);
      for (let i = 0; i < this.product.photosIds.length; i++)
        if (removed.includes(this.product.photosIds[i]))
          this.product.photosIds.splice(i, 1);
    }
  }

  getUrlImg(mediaId: string, crop: string = 'avatarL') {
    return `${environment.mediaUrl}api/Media/v/${mediaId}/${crop}`;
  }

  private isFileAllowed(fileName: string): any {
    let isFileAllowed = false;
    const allowedFiles = ['.jpeg', '.jpg', '.png'];
    const regex = /(?:\.([^.]+))?$/;
    const extension = regex.exec(fileName.toLowerCase());

    if (undefined !== extension && null !== extension) {
      for (const ext of allowedFiles) {
        if (ext === extension[0]) {
          isFileAllowed = true;
        }
      }
    }
    if (!isFileAllowed) {
      // Тост
      console.log(`Файл ${fileName} имеет недопустимое расширение`)
    }
    return isFileAllowed;
  }
}
